import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { FakeText, Typography, Card } from '@totalsoft/rocket-ui';
import EngineIntervalListComponent from './EngineIntervalListComponent';
import { List } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const EngineIntervalListContainer = ({
  intervals,
  onSave,
  containerDispatcher,
  isReadOnly,
  validation,
  loading,
  dictionaryScoringResponseColor
}) => {
  const { t } = useTranslation();

  const onAddNewEngineInterval = () => {
    containerDispatcher({
      type: 'OnAddNewEngineInterval'
    });
  };

  const onSaveEngineIntervals = () => {
    onSave('OnSaveEngineIntervals', {});
  };

  return loading ? (
    <FakeText lines={10} />
  ) : (
    <Card
      icon={List}
      iconColor='primary'
      title={t('EngineScoring.EngineInterval.Title')}
      actions={
        <>
          <IconButton
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Tooltips.EngineScoringGrid.AddInterval')}
            onClick={onAddNewEngineInterval}
            disabled={isReadOnly}
          />
          <IconButton
            type='save'
            fontSize='medium'
            color='transparent'
            tooltip={t('SaveChanges')}
            onClick={onSaveEngineIntervals}
            disabled={!intervals.changed || isReadOnly || !(validation |> isValid) || intervals.saving}
          />
        </>
      }
      subheader={<Typography color='error'>{validation |> getErrors}</Typography>}
    >
      <EngineIntervalListComponent
        containerDispatcher={containerDispatcher}
        dictionaryScoringResponseColor={dictionaryScoringResponseColor}
        intervals={intervals}
        isReadOnly={isReadOnly}
        loading={loading}
        validation={validation}
      />
    </Card>
  );
};

EngineIntervalListContainer.propTypes = {
  intervals: PropTypes.object.isRequired,
  containerDispatcher: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  dictionaryScoringResponseColor: PropTypes.array.isRequired
};

export default EngineIntervalListContainer;
